import { createFileRoute } from '@tanstack/react-router';
import { SupplierListPage } from '@/pages/member-portal/suppliers/SupplierListPage';

function MemberPortalSuppliersRoute() {
	return <SupplierListPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/suppliers')({
	component: MemberPortalSuppliersRoute,
});
